import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const ref = useRef(null);

  const loadCount = async () => {
    try { const r = await api.get("/notifications/unread-count"); setCount(r.data.count || 0); } catch (_) {}
  };
  const loadItems = async () => {
    try { const r = await api.get("/notifications"); setItems(r.data || []); } catch (_) {}
  };

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) await loadItems();
  };

  const openItem = async (n) => {
    try { await api.post(`/notifications/${n.id}/read`); } catch (_) {}
    setOpen(false);
    loadCount();
    if (n.link) navigate(n.link);
  };

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); } catch (_) {}
    setCount(0);
    loadItems();
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notification-bell" className="relative p-2 hover:bg-neutral-100 rounded-full">
        <Bell size={20} weight={count > 0 ? "fill" : "regular"} className="text-[#1F4E8C]" />
        {count > 0 && (
          <span data-testid="notification-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-[#FF5500] text-white text-[10px] font-bold grid place-items-center rounded-full">
            {count > 9 ? "9+" : count}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-dropdown" className="absolute right-0 mt-2 w-80 bg-white border border-[#E5E5E5] shadow-lg z-50 max-h-[420px] overflow-y-auto">
          <div className="flex items-center justify-between px-4 py-3 border-b border-[#F0F0EE]">
            <div className="font-head font-semibold text-sm">Notifications</div>
            {items.length > 0 && <button onClick={markAll} className="text-xs text-[#1F4E8C] hover:text-[#FF5500]" data-testid="mark-all-read">Mark all read</button>}
          </div>
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-neutral-500">No notifications</div>
          ) : items.map((n) => (
            <button key={n.id} onClick={() => openItem(n)} data-testid={`notification-${n.id}`}
              className={`w-full text-left px-4 py-3 border-b border-[#F7F7F5] hover:bg-[#F7F7F5] ${n.read ? "opacity-60" : ""}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="mt-1.5 w-2 h-2 bg-[#FF5500] rounded-full flex-shrink-0" />}
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate">{n.title}</div>
                  {n.body && <div className="text-xs text-neutral-500">{n.body}</div>}
                </div>
              </div>
            </button>
          ))}
          <button onClick={() => { setOpen(false); navigate("/preferences"); }} data-testid="notification-prefs-link"
            className="w-full text-left px-4 py-3 text-xs text-[#1F4E8C] hover:bg-[#F7F7F5] border-t border-[#F0F0EE] font-semibold">
            Notification preferences →
          </button>
        </div>
      )}
    </div>
  );
}
